import * as React from 'react';
import * as s from './Comments.scss';
import * as get from 'lodash.get';
import { Text } from 'wix-style-react';
import { translate } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
var Comments = function (_a) {
    var t = _a.t, metaData = _a.metaData, footer = _a.footer;
    var notes = get(metaData, 'notes');
    var legalTerms = get(metaData, 'legalTerms');
    var firstLabel = get(footer, 'firstLabel');
    var secondLabel = get(footer, 'secondLabel');
    var formattedNotes = ReactHtmlParser(notes);
    var formattedLegalTerms = ReactHtmlParser(legalTerms);
    var shouldDisplayNotesSection = function () { return (firstLabel || notes); };
    var shouldDisplayLegalTermsSection = function () { return (secondLabel || legalTerms); };
    var firstLabelIfNeeded = function () {
        if ((firstLabel === null || firstLabel === undefined) && notes) {
            return t('invoice-view:price-quote.view.notes');
        }
        if (firstLabel && notes) {
            return firstLabel;
        }
        return null;
    };
    var secondLabelIfNeeded = function () {
        if ((secondLabel === null || secondLabel === undefined) &&
            legalTerms) {
            return t('invoice-view:price-quote.view.legal-terms');
        }
        if (secondLabel && legalTerms) {
            return secondLabel;
        }
        return null;
    };
    return (!!(notes || legalTerms) && (React.createElement("div", null,
        React.createElement("div", { className: s.divider }),
        React.createElement("div", { className: s.comments },
            shouldDisplayNotesSection && (React.createElement("div", { className: s.comment },
                React.createElement(Text, { size: 'tiny', secondary: true, light: true, weight: 'normal', dataHook: "notes-label" }, firstLabelIfNeeded()),
                !!notes && (React.createElement(Text, { listStyle: "circle", size: 'tiny', secondary: true, light: true, dataHook: "notes-text" }, formattedNotes)))),
            shouldDisplayLegalTermsSection && (React.createElement("div", { className: s.comment },
                React.createElement(Text, { size: 'tiny', secondary: true, light: true, weight: 'normal', dataHook: "legal-terms-label" }, secondLabelIfNeeded()),
                !!legalTerms && (React.createElement(Text, { listStyle: "circle", size: 'tiny', secondary: true, light: true, dataHook: "legal-terms-text" }, formattedLegalTerms))))))));
};
export default translate(['invoice-view', 'locale-data'])(Comments);
//# sourceMappingURL=Comments.js.map